export class PdfViewerError extends Error {
    readonly status: number;

    constructor(status: number) {
        super(`Request failed with status ${status}`);
        this.name = 'PdfViewerError';
        this.status = status;
    }
}

export const createAbortError = (): Error => {
    const error = new Error('Aborted');
    error.name = 'AbortError';
    return error;
};

export const isAbortError = (error: unknown): boolean => (error as { name?: string })?.name === 'AbortError';

export const isUnauthorized = (error: unknown): boolean => error instanceof PdfViewerError && error.status === 401;

const HTTP_TOO_MANY_REQUESTS = 429;

export const isRateLimited = (error: unknown): boolean => error instanceof PdfViewerError
    && error.status === HTTP_TOO_MANY_REQUESTS;
